import useFetchData from "hooks/useFetchData";
import useAZZKULatestEditionID from "./useAZZKULatestEditionID";
import API from "api/API";

export default function useAZZKUIndustries() {
   const edition_id = useAZZKULatestEditionID();
   return useFetchData({
      APIMethod: API.getAZZKUIndustries,
      condition: !!edition_id,
      cache_name: "azzku_industries",
      params: [ edition_id ],
      resultDataHandler: data => data.map( item => ({
         value: item.id,
         label: item.name
      }))
   })
}